import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDom from 'react-dom';
import classNames from 'classnames';
/**
 *
 * @export
 *
 * This component is used to create a react portal.
 *
 *
 * @example
 * ```
 *  <PortalContainer >
 *      {your content}
 *  </PortalContainer>
 * ```
 *
 * @example
 *  <PortalContainer
 *      hasBackdrop
 *      onClickBackdrop={() => {setShow(false)}}
 *      backdropStyles={{backgroundColor: "white"}}
 *  >
 *      {your content}
 *  </PortalContainer>
 *
 * @advanced
 */
const PortalContainer = (props) => {
    // root
    // create if not
    let rootElement = document.getElementById('portal-root');
    if (!rootElement) {
        rootElement = document.createElement('div');
        rootElement.setAttribute("id", 'portal-root');
        document.body.appendChild(rootElement);
    }
    // ref
    let backdropRef = React.useRef(null);
    // handle backdrop click
    const handleBackdropClick = (e) => {
        if (e.target == backdropRef.current && props.onClickBackdrop) {
            props.onClickBackdrop(e);
        }
    };
    // styles
    let styles = {};
    if (props.backdropStyles)
        styles = Object.assign({}, props.backdropStyles);
    // render content
    const renderPortal = () => {
        if (props.hasBackdrop) {
            return (_jsx("div", { className: classNames("uxpcore__portalbackdrop uxp-portal-backdrop", props.className), onClick: handleBackdropClick, ref: backdropRef, style: styles, children: props.children }));
        }
        return props.children;
    };
    return ReactDom.createPortal(renderPortal(), rootElement);
};
export default PortalContainer;
